import { render, staticRenderFns } from "./CovidModule.vue?vue&type=template&id=ad03a9c0&"
import script from "./CovidModule.vue?vue&type=script&lang=js&"
export * from "./CovidModule.vue?vue&type=script&lang=js&"
import style0 from "./CovidModule.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports